<script>
  import { fly } from "svelte/transition"; 
  export let title = "Dekatan"; 
  export let message = "Memproses perintah";
  export let color = "green";  
  let active=true;
  
  let uid= Math.random().toString(36).substring(2);
let frameid = "alert-"+uid;
 
  setTimeout(function() { active = false; }, 10000)
</script>
{#if active} 
    <div
      transition:fly={{ y: 500, duration: 700 }}
      class="w-full" id="{frameid}" on:click={()=>active=false}>
      <div
        class="w-full bg-{color}-300 mx-auto rounded p-2 color-white
        text-xs border-t border-r border-b border-4 border-{color}-600
        border-solid shadow-lg mb-2">
        <h2 class="relative flex items-center justify-between text-sm font-bold">
          <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            class="inline-block w-4 h-4">
            <path
              d="M4 8a6 6 0 0 1 4.03-5.67 2 2 0 1 1 3.95 0A6 6 0 0 1 16 8v6l3
              2v1H1v-1l3-2V8zm8 10a2 2 0 1 1-4 0h4z" />
          </svg>
          {title}</span>
          <span class="absolute top-0 right-0 -mt-2 text-sm font-bold text-gray-700" on:click={()=>active=false}>x</span>
        </h2>
        <p>{message}</p>
      </div>
    </div>   
    {/if}